import { useEffect, useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import { useItemsStore, useOrdersStore, useUIStore } from "../store";
import { useNavigationActions } from "./useNavigationActions";
import { useFindInMenu } from "./useFindInMenu";

export const useMainHomeLogic = () => {
  const { closeModal } = useNavigationActions();

  const setSection = useUIStore((s) => s.setSection);
  const section = useUIStore((s) => s.section);

  const orders = useOrdersStore((s) => s.orders);
  const menuData = useItemsStore((s) => s.menuData);
  const { findProduct } = useFindInMenu();

  const [searchParams] = useSearchParams();

  const productId = searchParams.get("product");
  const cartItemId = searchParams.get("cartItem");
  const urlTitle = searchParams.get("title");
  const urlPrice = searchParams.get("price");

  const overridePrice =
    urlPrice && !isNaN(Number(urlPrice)) ? Number(urlPrice) : null;

  const isModalOpen = Boolean(productId || cartItemId);

  // 🔥 SINGLE SOURCE OF TRUTH
  useEffect(() => {
    if (isModalOpen) {
      setSection("productModal");
    } else {
      setSection("home");
    }
  }, [isModalOpen, setSection]);

  // 🔥 PRODUCTO ACTIVO
  const plateToShow = useMemo(() => {
    if (!productId && !cartItemId) return null;

    const order = cartItemId
      ? orders.find((o) => o.cartItemId === cartItemId)
      : null;

    const id = order?.productId ?? productId;
    if (!id) return null;

    const product = findProduct(id);
    if (!product) return null;

    if (order?.urlOverride) {
      return {
        ...product,
        title: order.urlOverride.title,
        price: order.urlOverride.price,
      };
    }

    return {
      ...product,
      title: urlTitle ?? product.title,
      price: overridePrice ?? product.price,
    };
  }, [productId, cartItemId, orders, findProduct, urlTitle, overridePrice]);

  const cartItemToEdit = useMemo(() => {
    if (!cartItemId) return undefined;
    return orders.find((o) => o.cartItemId === cartItemId);
  }, [cartItemId, orders]);

  const total = useMemo(
    () => orders.reduce((acc, o) => acc + o.quantity * o.price, 0),
    [orders]
  );

  return {
    menuData,
    orders,
    total,
    plateToShow,
    cartItemToEdit,
    isModalVisible: isModalOpen,
    handleCloseModal: closeModal,
    section,
  };
};